module.exports = __webpack_public_path__ + "media/images/flags/th-2a27911fc59e5311f422f0185a57f0df.svg";